export default "__VITE_ASSET__BH$yh_M4__"